var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteicon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.14239L6 3.4709C6 2.30611 6 1.72371 6.34942 1.36186C6.69883 1 7.26121 1 8.38596 1L11.614 1C12.7388 1 13.3012 1 13.6506 1.36186C14 1.72371 14 2.30611 14 3.4709V5.14239",
    stroke: "#F25F5F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.2148V15.2148",
    stroke: "#F25F5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.2148V15.2148",
    stroke: "#F25F5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 20C8.64321 20 7.7012 19.999 6.97168 19.9248C6.26079 19.8525 5.85474 19.7182 5.54395 19.5166C5.28364 19.3477 5.05096 19.1396 4.85449 18.8994C4.62 18.6127 4.44189 18.2239 4.29199 17.5254C4.13815 16.8083 4.03364 15.8714 3.88477 14.5234L2.88086 5.43066L17.1172 5.43066L16.1133 14.5234C15.9644 15.8714 15.8599 16.8083 15.7061 17.5254C15.5562 18.2238 15.379 18.6127 15.1445 18.8994C14.948 19.1397 14.7145 19.3476 14.4541 19.5166C14.1434 19.7181 13.7379 19.8525 13.0273 19.9248C12.2977 19.999 11.3552 20 9.99902 20Z",
    stroke: "#F25F5F",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.12109H19",
    stroke: "#F25F5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon2);
export default __webpack_public_path__ + "static/media/deleteicon2.fc5eec9141f8c6331ad466c9a0e83814.svg";
export { ForwardRef as ReactComponent };